<template>
    <div id="pageTable">
        <v-container grid-list-xl fluid>
            <v-layout row wrap>
                <v-flex lg12>
                    <v-card>
                        <tabulation />
                    </v-card>
                </v-flex>
                <v-flex lg12 class="text-xs-center">
                    <img v-for="image in resolveAds" :key="image._id" :style="`height: ${image.height}px; width: ${image.width}px;`"  :src="resolveSrc(image.img)" alt=" " />
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>
<script>

import tabulation from './tabulation'
import { mapActions, mapState } from 'vuex'
export default {
  name: 'dashboardChronometer',
  components: {
    tabulation
  },
  mounted () {
    this.getAds()
  },
  computed: {
    ...mapState({
      adsList: state => state.advertising.list
    }),
    resolveAds () {
      if (!this.adsList) {
        return []
      }
      return this.adsList.filter(item => item.location === 'chronometerMatch' && item.active)
    }
  },
  methods: {
    ...mapActions({
      getAds: 'advertising/setInit'
    }),
    resolveSrc (image) {
      return process.env.VUE_APP_IMAGE_URL + image
    }
  }
}
</script>
